import { render, staticRenderFns } from "./GithubButton.vue?vue&type=template&id=332d5c94&scoped=true"
var script = {}
import style0 from "./GithubButton.vue?vue&type=style&index=0&id=332d5c94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "332d5c94",
  null
  
)

export default component.exports